module.exports = __webpack_public_path__ + "img/img-10.1c34abad.png";